/**
 * Soft-safe Move 3: Share/Copy/PNG/link wrappers (incomplete → SoftGate).
 * Soft-safe ②: softGate.ts behavior unchanged — call sites only relocated.
 * Soft-safe ①: runners still flow softGate → shareViewModel human face.
 * Soft-safe ③ / Growth 7·8: SoftGate/toast must not enter share payload.
 */
import type { CopyMode } from '../../lib/shareCopy'
import {
  getState,
  handLooksIncomplete,
  openSoftGate,
  setCaptureMode,
} from '../../state'
import {
  runCopyHandLink,
  runCopySummary,
  runSaveShareImage,
  runShareShareImage,
  runShareText,
} from '../softGate'

export async function copySummary(mode: CopyMode = 'both'): Promise<void> {
  if (handLooksIncomplete(getState().hand)) {
    openSoftGate('copy', mode)
    return
  }
  await runCopySummary(mode)
}

export async function onShareText(): Promise<void> {
  if (handLooksIncomplete(getState().hand)) {
    openSoftGate('share')
    return
  }
  await runShareText()
}

export async function onSaveShareImage(): Promise<void> {
  if (handLooksIncomplete(getState().hand)) {
    openSoftGate('png-save')
    return
  }
  await runSaveShareImage()
}

export async function onShareShareImage(): Promise<void> {
  if (handLooksIncomplete(getState().hand)) {
    openSoftGate('png-share')
    return
  }
  await runShareShareImage()
}

export async function copyHandLink(): Promise<void> {
  if (handLooksIncomplete(getState().hand)) {
    openSoftGate('link')
    return
  }
  await runCopyHandLink()
}

export function requestCaptureOn(): void {
  const { captureMode, hand } = getState()
  if (captureMode) {
    setCaptureMode(false)
    return
  }
  if (handLooksIncomplete(hand)) {
    openSoftGate('capture')
    return
  }
  setCaptureMode(true)
}

